<mat-sidenav-container *ngIf="ms.getSessionLevel() > 0" fullscreen>
  <mat-sidenav #sidenav mode="side" opened="true">

    <mat-toolbar class="left"><img src="../assets/img/ibex-logo-new.png"/></mat-toolbar>
    <mat-list *ngIf="navigationItems">
      <a *ngIf="dashboardRoute" (click)="navigateToPage(dashboardRoute)" mat-list-item>
        <mat-icon>dashboard</mat-icon>
        <span class="navigation-text-container">{{'pages.dashboard' | translate}}</span>
      </a>
      <ng-container *ngFor="let route of navigationItems">
        <ng-container *ngIf="!route?.data?.displayOptions || isVisible(route?.data?.displayOptions)">
          <a (click)="route.subRoutes ? route.open = !route.open : navigateToPage(route)" mat-list-item [ngClass]="{ main: !!route.icon }">
            <ng-container *ngIf="route.icon">
              <mat-icon *ngIf="route.icon.type === 'icon'">{{route.icon.name}}</mat-icon>
              <img *ngIf="route.icon.type === 'logo'" [src]="route.icon.url">
            </ng-container>
            <span class="navigation-text-container">{{route.noTranslation ? route.data.title : 'pages.' + route?.path | translate}}</span>
            <ng-container *ngIf="route.data && route.data.messageBubble">
              <message-bubble [dataFunctionName]="route.data.messageBubble.functionName"
                              [dataProviderName]="route.data.messageBubble.service"
                              [dataProviderParams]="route.data.messageBubble.params"></message-bubble>
            </ng-container>
          </a>
          <ng-container *ngIf="!!route.open">
            <a (click)="navigateToSubPage(subRoute, route.data.title)" *ngFor="let subRoute of route.subRoutes" mat-list-item class="sub-route {{subRoute.path}}"
            [ngClass]="{'activated': subRoute.activated}">
              <span class="navigation-text-container">{{subRoute.noTranslation ? subRoute.data.title : 'pages.' + subRoute?.path | translate}}</span>
            </a>
          </ng-container>
        </ng-container>
      </ng-container>
    </mat-list>
    <div class="footer">
      <mat-chip-listbox *ngIf="changeApi && realEnvironment !== selectedEnvironment">
        <mat-chip-option color="warn" selected="true">{{realEnvironment | uppercase}} on {{selectedEnvironment | uppercase}} API</mat-chip-option>
      </mat-chip-listbox>
      <mat-form-field *ngIf="changeApi">
        <mat-label>Change the API</mat-label>
        <mat-select (selectionChange)="changeEnvironment(selectedEnvironment)" [(ngModel)]="selectedEnvironment">
          <mat-option *ngFor="let api of availableApis" [value]="api" ng-selected="api === selectedEnvironment">{{api}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="links">
        <a href="https://ipeak.ch/uber-uns/agb/" target="_blank">
          <mat-icon>subject</mat-icon>
          <span>AGB</span>
        </a>
        <a href="https://ipeak.ch/uber-uns/datenschutz/" target="_blank">
          <mat-icon>vpn_lock</mat-icon>
          <span>Datenschutz</span>
        </a>
        <a href="https://ipeakinfosystems.atlassian.net/servicedesk/customer/portal/8" target="_blank">
          <mat-icon>mail</mat-icon>
          <span>Supportdesk</span>
        </a>
        <a href="https://www.splashtop.com/de/sos-download" target="_blank">
          <mat-icon>computer</mat-icon>
          <span>Splashtop</span>
        </a>
        <a href="https://ipeak.ch/tutorials/" target="_blank">
          <mat-icon>lightbulb</mat-icon>
          <span>Tutorials</span>
        </a>
      </div>
      <div class="kontakt">
        <img src="../assets/img/ipeak-infosystems-logo-new.png"/>
        <a href="https://ipeak.ch/" target="_blank">https://ipeak.ch</a>
        <a href="tel:+41 41 497 50 00">+41 41 497 50 00</a>
        <a href="mailto:welcome@ipeak.ch">welcome&#64;ipeak.ch</a>
      </div>

    </div>

  </mat-sidenav>

  <mat-toolbar class="right">
    <button (click)="toggleSidenav()" mat-icon-button class="toggle-button" [class.closed]="!sidenav.opened" [matTooltipPosition]="'right'"
            [matTooltip]="sidenav.opened ? ('general.collapse' | translate) : ('general.fold' | translate)">
      <mat-icon>menu_open</mat-icon>
    </button>
    <router-outlet name="org"></router-outlet>
    <span class="spacer"></span>
    <button [matMenuTriggerFor]="userMenu" mat-button class="profile-button">
      <mat-icon class="avatar">account_circle</mat-icon>
      <div *ngIf="profileName" class="name">{{profileName}} <mat-icon>expand_more</mat-icon></div>
    </button>
    <mat-menu #userMenu="matMenu" [overlapTrigger]="false" x-position="before">
      <button (click)="navigateToProfile()" *ngIf="!disableMyProfile" mat-menu-item class="menu-button">
        <mat-icon>person</mat-icon>
        <span>{{'general.myProfile' | translate}}</span>
      </button>
      <button (click)="navigateToOrganization()" *ngIf="!disableMyProfile" mat-menu-item class="menu-button">
        <mat-icon>business</mat-icon>
        <span>{{'general.organisation' | translate}}</span>
      </button>
      <button (click)="logout()" mat-menu-item class="menu-button">
        <mat-icon>logout</mat-icon>
        <span>{{'general.logout' | translate}}</span>
      </button>
    </mat-menu>
    <button (click)="toggleReadme()" class="ibexfusion-icon-button help" mat-icon-button style="display: none">
      <mat-icon>help</mat-icon>
    </button>
  </mat-toolbar>

  <div class="content">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>

  <mat-sidenav #rightsidebar class="rightsidebar" mode="side" position="end">
    <button (click)="toggleReadme()" mat-icon-button>
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
    <readme></readme>
  </mat-sidenav>

</mat-sidenav-container>

<div *ngIf="(ms.getSessionLevel() <= 0) && isLoading" class="background"></div>
<div *ngIf="(ms.getSessionLevel() === 0) && isLoading">
  <div class="content-no-login">
    <mat-card>
      <div style="text-align:center;align-self:start"><img src="../../assets/img/ibex-logo-text-new-new.png"/></div>
      Error: <a [routerLink]="['/']" mat-button style="color:black"> go to login </a>
    </mat-card>
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
</div>

<div class="content">
  <router-outlet name="auth"></router-outlet>
</div>

<ng-template #template>
  <ibex-snackbar></ibex-snackbar>
  <router-outlet></router-outlet>
</ng-template>
